import Vue from 'vue';

// initial state
const state = {
  legalVisible: false,
  debugLog: '',
};

// getters
const getters = {
  getLegalVisible(state) {
    return state.legalVisible;
  },
};

// actions
const actions = {
  setLegalVisible({commit, state}, value) {
    commit('setLegalVisible', {legalVisible:value});
  },

  setDebugLog({commit, state}, value) {
    commit('setDebugLog', {debugLog:value});
  },
};

// mutations
const mutations = {
  setLegalVisible(state, payload) {
    state.legalVisible = payload.legalVisible;
  },

  setDebugLog(state, payload) {
    state.debugLog = payload.debugLog;
    // document.querySelector('#debugLog').innerText = payload.debugLog;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
